const parseTheAdditionInfo = (element) => {
  const formattedData = element.Additional_Info.trim() // Trim any extra spaces at the start and end
    .replace(/,\s+/g, ",") // Remove space after commas
    .replace(/([a-zA-Z0-9_]+):/g, '"$1":') // Add double quotes around object keys
    .replace(/,\s*}/g, "}") // Remove trailing commas, if any
    .replace(/^"|"$/g, "'");
  // console.log(formattedData, "elementformattedData")
  // Step 2: Parse the formatted data into JSON
  const jsonData = JSON.parse(formattedData);
  const mergedElement = { ...element, ...jsonData };
  return mergedElement;
};

const parseFormulaOnly = (data) => {
  return data.map((e) => {
    // clone the element
    let parsedElement = { ...e };

    if (e.Additional_Info && e.Additional_Info.trim()) {
      let s = e.Additional_Info.trim();

      // ensure it's a JS object literal
      if (!s.startsWith("{")) {
        s = `{${s}}`;
      }

      try {
        const obj = new Function(`return ${s}`)();

        // if parsing is successful and result is an object
        if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
          parsedElement = { ...parsedElement, ...obj };
        }
      } catch (err) {
        console.error("Failed to parse Additional_Info:", err);
        // leave parsedElement unchanged
      }
    }

    return parsedElement;
  });
};

export { parseTheAdditionInfo, parseFormulaOnly };
